import React, { ReactElement } from 'react';
import CompanyDealsWidget from '../../../../components/widgets/Deals/CompanyDealsWidget/CompanyDealsWidget';
import PageComponentWidget from '../../../../components/widgets/PageComponent';
import CompanyOverviewWidget from '../../../../components/widgets/CompanyOverview';
import CSViewCompanyWidget from '../../../../components/widgets/CSView/CSViewCompanyWidget';
import RecentlyPublished from '../../../../components/widgets/RecentlyPublished/RecentlyPublishedWidget';
import RiskProductsWidget from '../../../../components/widgets/RiskProducts';
import { PageComponentsMap, PageComponentTagId } from '../../../../models';
import { IssuerDto } from '../../../../services/dtos/issuer/issuer.dto';
import { STATIC_PRINTABLE_SECTIONS } from '../../CompanyPrintAction/CompanyPrintAction.constants';
import { useRecentlyPublishedContext } from '../../CompanyRecentlyPublishedContext';

interface CompanyOverviewPrintViewSectionProps {
  section: string;
  pageComponentsMap: PageComponentsMap;
  company: IssuerDto;
}

const CompanyOverviewPrintViewSection = ({
  section,
  pageComponentsMap,
  company,
}: CompanyOverviewPrintViewSectionProps): ReactElement | null => {
  const recentlyPublishedProps = useRecentlyPublishedContext();
  const isDynamicSection = !!pageComponentsMap[section];
  if (isDynamicSection) {
    return <PageComponentWidget component={pageComponentsMap[section]} />;
  }

  const businessDescriptionComponent = pageComponentsMap[PageComponentTagId.BUSINESS_DESCRIPTION];
  switch (section) {
    case STATIC_PRINTABLE_SECTIONS.COMPANY_OVERVIEW.id:
      return <CompanyOverviewWidget company={company} companyCoverageComponent={businessDescriptionComponent} print />;
    case STATIC_PRINTABLE_SECTIONS.CS_VIEW.id:
      return <CSViewCompanyWidget recommendation={company.latestRec} issuerTag={company.tagId} print />;
    case STATIC_PRINTABLE_SECTIONS.RISK_PRODUCTS.id:
      return <RiskProductsWidget companyTag={company.tagId} print />;
    case STATIC_PRINTABLE_SECTIONS.RECENTLY_PUBLISHED.id:
      return <RecentlyPublished print issuerTag={company.tagId} {...recentlyPublishedProps} />;
    case STATIC_PRINTABLE_SECTIONS.DEALS.id:
      return <CompanyDealsWidget companyTagId={company.tagId} print />;
    default:
      return null;
  }
};

export default CompanyOverviewPrintViewSection;
